



























































































































































































import { createComponent, inject, ref, reactive } from '@vue/composition-api'

import { useAppState } from '../lib/appState'
import { useAlertState } from '../lib/useAlert'

import { MainMapControllerSymbol } from '../symbols'
import { MapFactoryController } from '../lib/map'
import { createFactory } from '../api'
import { useImageUpload } from '../lib/imageUpload'

import ImageUploadForm from './ImageUploadForm.vue'
import ConfirmFactory from './ConfirmFactory.vue'
import SwitchMapModeButton from './SwitchMapModeButton.vue'
import { FactoryPostData } from '../types'
import { useGA } from '../lib/useGA'
import { useBackPressed } from '../lib/useBackPressed'
import { useModalState } from '../lib/hooks'

export default createComponent({
  name: 'CreateFactorySteps',
  components: {
    ImageUploadForm,
    ConfirmFactory,
    SwitchMapModeButton
  },
  setup () {
    const [appState, { pageTransition, setFactoryLocation }] = useAppState()
    const [, { openCreateFactorySuccessModal }] = useModalState()
    const [, alertActions] = useAlertState()
    const { event } = useGA()

    const discardDialog = ref(false)

    const mapController = inject(MainMapControllerSymbol, ref<MapFactoryController>())

    function cancelCreateFactory () {
      if (mapController.value) {
        mapController.value.mapInstance.setLUILayerVisible(false)
        discardDialog.value = false
        // TODO: clear form value
        pageTransition.closeFactoryPage()
      }
    }

    const onBack = () => {
      if (appState.createStepIndex === 1) {
        cancelCreateFactory()
      } else if (appState.createStepIndex === 2) {
        if (mapController.value) {
          mapController.value.mapInstance.setLUILayerVisible(true)
          pageTransition.previousCreateStep()
        }
      } else {
        pageTransition.previousCreateStep()
      }
    }
    useBackPressed(onBack)

    const createFactoryFormState = reactive({
      nickname: '',
      contact: '',
      others: '',
      name: '',
      type: undefined,
      submitting: false
    })

    const {
      selectedImages,
      imageUploadState,
      uploadedImages,
      onClickRemoveImage,
      imageUploadFormValid
    } = useImageUpload()

    const submitFactory = async () => {
      createFactoryFormState.submitting = true

      try {
        const [lng, lat]: number[] = appState.factoryLocation
        const factory: FactoryPostData = {
          name: createFactoryFormState.name,
          others: createFactoryFormState.others,
          type: createFactoryFormState.type,
          lng,
          lat,
          images: uploadedImages.value.map(i => i.token),
          nickname: createFactoryFormState.nickname,
          contact: createFactoryFormState.contact
        }

        event('createFactory', { lng, lat })
        const resultFactory = await createFactory(factory)
        if (mapController.value) {
          mapController.value.addFactories([resultFactory])
        }
      } catch (e) {
        // TODO: handle create failure
      } finally {
        createFactoryFormState.submitting = false
      }

      // TODO: if error, don't close factory page
      pageTransition.closeFactoryPage()

      openCreateFactorySuccessModal()
    }

    const showLongLat = ref(false)
    const toggleShowLongLat = () => {
      showLongLat.value = !showLongLat.value
    }

    const chooseLocationDialog = ref(false)
    const inlineLocationForm = ref(false)
    const toggleInlineLocationForm = () => {
      inlineLocationForm.value = !inlineLocationForm.value
    }
    const locationInputState = reactive({
      longitude: '',
      latitude: ''
    })
    const clearLocationInput = () => {
      locationInputState.longitude = ''
      locationInputState.latitude = ''
    }
    const setLocation = () => {
      if (!mapController.value) return

      const lng = parseFloat(locationInputState.longitude)
      const lat = parseFloat(locationInputState.latitude)
      if (!locationInputState.longitude ||
          !locationInputState.latitude ||
          isNaN(lng) ||
          isNaN(lat)
      ) {
        // TODO: show invalid input error
        chooseLocationDialog.value = false
      } else {
        let zoom = mapController.value.mapInstance.map.getView().getZoom()
        if (!zoom || zoom <= 17) {
          zoom = 17
        }
        mapController.value.mapInstance.setCoordinate(lng, lat, zoom)
        chooseLocationDialog.value = false
      }
    }

    const switchStep = (num: number) => {
      const backSteps = appState.createStepIndex - num

      for (let i = 0; i < backSteps; i++) {
        onBack()
      }
    }

    return {
      appState,
      pageTransition,
      formState: createFactoryFormState,

      cancelCreateFactory,
      onBack,
      chooseLocation () {
        if (!mapController.value) return

        if (!appState.canPlaceFactory) {
          alertActions.showAlert('此地點不在農地範圍內，\n請回報在農地範圍內的工廠。')
          return
        }

        mapController.value.mapInstance.setLUILayerVisible(false)

        setFactoryLocation(appState.mapLngLat as [number, number])

        pageTransition.nextCreateStep()
      },
      selectedImages,
      imageUploadState,
      uploadedImages,
      onClickRemoveImage,
      imageUploadFormValid,
      discardDialog,
      submitFactory,
      showLongLat,
      toggleShowLongLat,
      chooseLocationDialog,
      inlineLocationForm,
      locationInputState,
      clearLocationInput,
      toggleInlineLocationForm,
      setLocation,
      switchStep
    }
  }
})
